


















import { Vue, Component, Watch } from 'vue-property-decorator';
import FlagUtil from '@/util/FlagUtil';
import { PartnersApi, Partner } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import PartnerModule from '@/store/modules/partner';

@Component({
  components: {},
})
export default class Sidebar extends Vue {
  public partnerInfo: Partner = {};

  private sideNavigation = [
    {
      title: 'Basic Information',
      route: {
        name: 'partner-detail',
      },
    },
    {
      title: 'Forms',
      route: {
        name: 'document-list',
      },
    },
    {
      flag: 'partner.scheduleSettings',
      title: 'Schedule Settings',
      route: {
        name: 'schedule-settings-partners',
      },
      prop: 'enabledScheduling',
    },
  ];

  get activePartner() {
    return PartnerModule.activePartner;
  }

  // Details page loads partner once; sidebar reuses Vuex
  @Watch('activePartner', { immediate: true })
  onActivePartnerChange(partner: Partner) {
    if (partner?.id === this.$route.params.id) {
      this.partnerInfo = partner;
    }
  }

  public mounted() {
    this.ensurePartner();
  }

  @Watch('$route')
  onRouteChange() {
    this.ensurePartner();
  }

  public async ensurePartner() {
    const partnerId = this.$route.params.id;
    if (PartnerModule.activePartner?.id === partnerId) {
      this.partnerInfo = PartnerModule.activePartner;
      return;
    }
    // Basic Information owns the partners/:id fetch on page load
    if (this.$route.name === 'partner-detail') {
      return;
    }
    // Forms / Schedule deep-link: fetch only if not already cached
    const { data } = await new PartnersApi(AppModule.apiConfig).getPartnerById(partnerId);
    this.partnerInfo = data;
    PartnerModule.SET_ACTIVE_PARTNER(data);
  }

  get enabledScheduling() {
    const { marketId } = PartnerModule.activePartner;

    if (FlagUtil.getFlags().market.scheduler_disabled.includes(marketId)) {
      return false;
    }

    const enabled = FlagUtil.getFlags().market.scheduler_enabled;
    if (enabled && enabled.includes(marketId)) {
      return true;
    }
    return false;
  }

  hasFlag(flag?: string) {
    if (!flag) return true;
    return FlagUtil.hasFeature(flag);
  }

  checkProp(prop?: string) {
    if (!prop) return true;
    return this[prop];
  }
}
